const iconfield = {
  icon: {
    color: '{form.field.icon.color}',
  },
};

export default iconfield;
